import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Loadingcomponent from "../loader/loadingcomponent";
import {
  isContainAlphabet
} from "../../services/common/utils";
import Lottie from "lottie-react";
import verified from "../../../src/verified.json";


const MessageModal = ({
  type = "1",
  show,
  toggleModal,
  title = '',
  message,
  handleOk,
  handleCancel,
  handleConfirm,
  cancel,
  confirm,
  loading,
  pBtnText,
  actionText,
  handleAction,
  nBtnText,
  handleStaySignInClose,
  isBackdropClickAllowed = false,
  setShowVerificationSuccess
}) => {
  const { t } = useTranslation();
  const posBtnText = pBtnText ? pBtnText : 'continue';

  useEffect(()=>{
    if(show && type === 'verification-successfull'){
      setTimeout(()=>{
        setShowVerificationSuccess(false);
      }, [1500])
    }
  }, [show])
  // close_icon + heading + message
  if (type === "1") {
    return (
      <Modal
        show={show}
        backdrop="true"
        className="modal bottom_modal animated  slideInUp faster popup2 country-accro-comp1 sp16-modal-bounce-effect"
        onHide={toggleModal}
      >
        <Modal.Header className="border-0">
          <h6 className="dir-ltrl">{title}</h6>

          <button className="badges-close-button" onClick={toggleModal}>
            <img
              src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
              alt=""
              title=""
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="badges-container">
            <p>{message}</p>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  // info_icon + message + ok_button
  if (type === "2") {
    return (
      <Modal
        show={show}
        backdrop={isBackdropClickAllowed ? "true" : "static"}
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
        onHide={ isBackdropClickAllowed ? handleOk : () => {}}
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/Confirmation.gif"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="mt-4">
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block"
              data-bs-dismiss="modal"
              onClick={handleOk}
            >
              {t("ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  // info_icon + cancel_button + confirm_button
  if (type === "3") {
    return (
      <Modal
        show={show}
        backdrop="static"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {t("cancel")}
            </button>
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block ms-2"
              onClick={handleConfirm}
              disabled={loading === true ? true : false}
            >
              {loading ? <Loadingcomponent /> : t(posBtnText)}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  //transfer points modal
  if (type === "4") {
    return (
      <Modal
        show={show}
        backdrop="static"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {cancel}
            </button>
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block ms-2"
              onClick={handleConfirm}
              disabled={loading === true ? true : false}
            >
              {loading ? <Loadingcomponent /> : confirm}
            </button>
          </div>
        </Modal.Body>
      </Modal>

    );
  }

  // transaction status
  if (type === "5") {
    return (
      <Modal
        show={show}
        backdrop="true" 
        //backdrop="static"
         onHide={toggleModal}
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/Thumbs_up.svg'}
              width={60}
              alt=""
              title=""
            />
          </div>
          <h6 className="dir-ltrl">{title}</h6>
          <p className="modal_p">{message}</p>
          {/* "mob_flex_grp_align_center" class below to fix issue specific to ar lang */}
          <div className="flex_grp_align_center mob_flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {t("home")}
            </button>
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block ms-2"
              onClick={handleConfirm}
              disabled={loading === true ? true : false}
            >
              {loading ? <Loadingcomponent /> : t("chatwithagent")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  if (type === "6") {
    return (
      <Modal
        show={show}
        backdrop="true"
        onHide={toggleModal}
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="mt-4">
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block"
              data-bs-dismiss="modal"
              onClick={handleOk}
            >
              {t("ok")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  //wifi login case

  if (type === "7") {
    return (
      <Modal
        show={show}
        backdrop="static"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/wifi.png"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {t("cancel")}
            </button>
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block ms-2"
              onClick={handleConfirm}
              disabled={loading === true ? true : false}
            >
              {loading ? <Loadingcomponent /> : t(posBtnText)}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  //ooredeo redeem rtl case
  if (type === "8") {
    return (
      <Modal
        show={show}
        backdrop="static"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {t("cancel")}
            </button>
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block ms-2"
              onClick={handleConfirm}
              disabled={loading === true ? true : false}
            >
              {loading ? <Loadingcomponent /> : t(posBtnText)}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  //smart pay delete model
  if (type === "12") {
    return (
      <Modal
        show={show}
        backdrop="static"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {cancel}
            </button>
          </div>
        </Modal.Body>
      </Modal>

    );
  }
//pay page modal
if (type === "9") {
  return (
    <Modal
      show={show}
      backdrop="true"
      onHide={handleCancel}
      className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
    >
      <Modal.Body className="text-center">
        <div className="modal_img mb-4">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
            width={60}
            alt=""
            title=""
          />
        </div>
        <p className="modal_p"
          style={{"direction":isContainAlphabet(message) ? "ltr" :""}}>
        {message}</p>
        <div className="mt-4 flex_grp_align_center flex-column w-50 mx-auto">
          <button
            type="button"
            className="custom_btn custom_btn_primary btn_block mb-4"
            data-bs-dismiss="modal"
            onClick={handleOk}
          >
            {t("ok")}
          </button>
          <button
              type="button"
              style={{background: 'none', border:'none'}}
              className="custom_btn btn_block me-2"
              onClick={handleCancel}
            >
              {t("cancel")}
            </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

  // info_icon + title + message + action + ok
  if (type === '10') {
    return (
      <Modal
        show={show}
        onHide={toggleModal}
        backdrop="true"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/confirm_popup.svg'}
              width={60}
              alt=""
              title=""
            />
          </div>

          {title && (
            <>
              <h6 className="dir-ltrl">{title}</h6>
              <div class="radiobutton-comp pb-0 p-3 border-r16">
                <div class="pay-cont">
                  <div class="country-accro-comp p-0">
                    <div class="roaming-rates-col" onClick={handleAction}>
                      <div class="d-flex align-items-center img-size01">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            '/assets/images/Tranfer%20credit.svg'
                          }
                          alt=""
                          title=""
                        />
                        {actionText}
                      </div>
                      <div class="right-arrow">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            '/assets/images/arrow_right_dark.svg'
                          }
                          alt=""
                          title=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {message && (
            <>
              <p className="modal_p">{message}</p>

              <div className="mt-4">
                <button
                  type="button"
                  className="custom_btn custom_btn_primary btn_block"
                  data-bs-dismiss="modal"
                  onClick={handleOk}
                >
                  {t('ok')}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    );
  }
  
//ooredeo redeem rtl case
if (type === "11") {
  return (
    <Modal
      show={show}
      backdrop="static"
      className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect" 
    >
      <Modal.Body className="text-center">
        <div className="modal_img mb-4">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
            width={60}
            alt=""
            title=""
          />
        </div>
        <p className="modal_p">{message}</p>
        <div className="flex_grp_align_center">
          <button
            type="button"
            className="custom_btn custom_btn_primary_outline btn_block me-2"
            onClick={handleCancel}
          >
            {t("cancel")}
          </button>
          <button
            type="button"
            className="custom_btn custom_btn_primary btn_block ms-2"
            onClick={handleConfirm}
            disabled={loading === true ? true : false}
          >
            {loading ? <Loadingcomponent /> : t(posBtnText)}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
if (type === "13") {
  return (
    <Modal
      show={show}
      backdrop="true"
      className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      onHide={handleCancel}
    >
      <Modal.Body className="text-center">
        <div className="modal_img mb-4">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
            width={60}
            alt=""
            title=""
          />
        </div>
        <p className="modal_p">{message}</p>
        <div className="flex_grp_align_center">
          <button
            type="button"
            className="custom_btn custom_btn_primary_outline btn_block me-2"
            onClick={handleCancel}
          >
            {t("cancel")}
          </button>
          <button
            type="button"
            className="custom_btn custom_btn_primary btn_block ms-2"
            onClick={handleConfirm}
            disabled={loading === true ? true : false}
          >
            {loading ? <Loadingcomponent /> : t(posBtnText)}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

  // info_icon + cancel_button + confirm_button with backdrop
  if (type === "3A") {
    return (
      <Modal
        show={show}
        backdrop="true"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
        onHide={handleCancel}
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/confirm_popup.svg"}
              width={60}
              alt=""
              title=""
            />
          </div>
          <p className="modal_p">{message}</p>
          <div className="flex_grp_align_center">
            <button
              type="button"
              className="custom_btn custom_btn_primary_outline btn_block me-2"
              onClick={handleCancel}
            >
              {t("cancel")}
            </button>
            <button
              type="button"
              className="custom_btn custom_btn_primary btn_block ms-2"
              onClick={handleConfirm}
              disabled={loading === true ? true : false}
            >
              {loading ? <Loadingcomponent /> : t(posBtnText)}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  if(type === 'stay-sign-in'){
    return (
      <Modal
      show={show}
      backdrop="true"
      className="modal bottom_modal animated slideInUp faster popup2 country-accro-comp1 p-0 sprint16-modal-popup sp16-modal-bounce-effect"
      onHide={handleStaySignInClose ? handleStaySignInClose : handleConfirm}
    >
      <Modal.Header className="border-0">
        <h6 className="dir-ltrl"></h6>

        <button className="badges-close-button" 
        onClick={handleStaySignInClose ? handleStaySignInClose : handleConfirm}
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
            alt="close-icon"
          />
        </button>
      </Modal.Header>
      <Modal.Body>
      <div className="modal_img mb-4 text-center">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/Confirmation.gif"}
              width={60}
              alt="info-icon"
            />
          </div>
      <div className="sprint16-delete-acc-popup">
      <h6>{title}</h6>
      <p>{message}</p>

      <div class="flex_grp_align_center mt-4">
              <button class={`custom_btn custom_btn_primary_outline btn_block me-2 sp16_custom_btn
              ${loading ? 'disabled_border' : ''}`}
               onClick={handleCancel}
              disabled={loading}
              >
              {
                  loading ? <Loadingcomponent /> : t(nBtnText)
                }
              </button>
              <button class="custom_btn custom_btn_primary btn_block ms-2 sp16_custom_btn" onClick={handleConfirm}>
              {t(posBtnText)}
              </button>
      </div>
      </div>
      </Modal.Body>
    </Modal>
    )
  }

  if(type === 'verification-successfull'){
    return (
      <Modal
      show={show}
      backdrop="false"
      className="modal bottom_modal animated slideInUp faster popup2 country-accro-comp1 p-0 sprint16-modal-popup"
    >
      <Modal.Body>
      <div className="sprint16-delete-acc-popup">
      <h6>{t('verification_successfull')}</h6>

      <div className="sp16-verification-success">
         <Lottie animationData={verified} loop={true} />
        </div>
        </div>
      </Modal.Body>
    </Modal>
    )
  }

  // sprint-16 new bottom popup
  // icon + title + message + 2 action button
  if(type === 'sprint16popup'){
    return (
      <Modal
      show={show}
      backdrop="true"
      className="modal bottom_modal animated slideInUp faster popup2 country-accro-comp1 p-0 sprint16-modal-popup sp16-modal-bounce-effect"
      onHide={handleCancel}
    >
      <Modal.Header className="border-0">
        <h6 className="dir-ltrl"></h6>

        <button className="badges-close-button" 
        onClick={handleCancel}
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/images/cross_dark.svg"}
            alt="close-icon"
          />
        </button>
      </Modal.Header>
      <Modal.Body>
      <div className="modal_img mb-4 text-center">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/Confirmation.gif"}
              width={60}
              alt="info-icon"
            />
          </div>
      <div className="sprint16-delete-acc-popup">
      <h6>{title}</h6>
      <p>{message}</p>

      <div class="flex_grp_align_center mt-4">
              <button class={`custom_btn custom_btn_primary_outline btn_block me-2 sp16_custom_btn`}
               onClick={handleCancel}
              >
              {t(nBtnText)}
              </button>
              <button class={`custom_btn custom_btn_primary btn_block ms-2 sp16_custom_btn ${loading ? 'disabled_border' : ''}`} onClick={handleConfirm} disabled={loading}>
                {
                  loading ? <Loadingcomponent /> : t(posBtnText)
                }
              </button>
      </div>
      </div>
      </Modal.Body>
    </Modal>
    )
  }
  if (type === 'verification-successfull') {
    return (
      <Modal
        show={show}
        backdrop="static"
        className="bottom_modal animated  slideInUp faster sp16-modal-bounce-effect"
      >
        <Modal.Body className="text-center">
          <div className="modal_img mb-4">
            <p className="modal_p">{message}</p>
            <Lottie animationData={verified} loop={true} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
};
export default MessageModal;
